import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

const PackerCounter = ({ count, onIncrease, onDecrease, onReset }) => {
  return (
    <div className="text-large">
      <FontAwesomeIcon
        size="lg"
        onClick={() => (count > 0 ? onDecrease() : onReset())}
        className="m-r-1"
        icon={faMinusCircle}
      />
      {count === null ? '-' : count}
      <FontAwesomeIcon
        size="lg"
        onClick={() => (count === null ? onReset() : onIncrease())}
        className="m-l-1"
        icon={faPlusCircle}
      />
    </div>
  );
};

PackerCounter.propTypes = {};

PackerCounter.defaultProps = {};

export default PackerCounter;
